import { useMemo, useState } from "react";
import { clinicLabel } from "@utils/utils";
import ProfileDirectoryPage from "@pages/reporting/ProfileDirectoryPage";

const ALL_CLINICS = "__all__";

/**
 * Clinic selector + practitioner directory; shared by Admin and Management dashboards.
 */
export default function ProfileDirectoryTabPanel({ clinics, role }) {
  const [selectedProfileClinic, setSelectedProfileClinic] = useState(ALL_CLINICS);
  const profileClinicOptions = useMemo(
    () =>
      clinics
        .map((c) => ({
          value: c.clinic,
          label: clinicLabel(c),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [clinics],
  );

  const isAll = selectedProfileClinic === ALL_CLINICS;

  return (
    <div className="mt-4">
      {profileClinicOptions.length === 0 ? (
        <div className="rounded-xl border border-palette-amber-border bg-palette-amber-soft px-4 py-3 text-sm text-palette-amber-primary">
          No clinics available. Select a date or check your assigned clinics.
        </div>
      ) : (
        <>
          <div className="mb-4 flex items-center gap-3">
            <label className="text-sm font-medium text-palette-slate-heading">Clinic</label>
            <select
              value={selectedProfileClinic}
              onChange={(e) => setSelectedProfileClinic(e.target.value)}
              className="rounded-lg border border-palette-slate-ring px-3 py-2 text-sm focus:border-palette-indigo-label focus:outline-none focus:ring-1 focus:ring-palette-indigo-label"
            >
              <option value={ALL_CLINICS}>All Clinics</option>
              {profileClinicOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="mx-auto w-full max-w-5xl px-0">
            <ProfileDirectoryPage
              clinicId={isAll ? null : selectedProfileClinic}
              serverPaginated
              role={role}
              onUpdatePractitioner={null}
              onViewPractitioner={null}
            />
          </div>
        </>
      )}
    </div>
  );
}
